<template>
  <div class="countdown"  :class="type">
    <div v-if="days" class="countdown__block">
      <div class="countdown-digit"  :class="type">{{ twoDigits(days) }}</div>
      <div class="countdown-text" v-if="labels">Days</div>
    </div>
    <div class="countdown-block">
      <div class="countdown-digit">{{ twoDigits(hours) }}</div>
      <div class="countdown-text" v-if="labels">Hrs</div>
    </div>
    <div class="countdown-block">
      <div class="countdown-digit">{{ twoDigits(minutes) }}</div>
      <div class="countdown-text" v-if="labels">Min</div>
    </div>
    <div class="countdown-block">
      <div class="countdown-digit">{{ twoDigits(seconds) }}</div>
      <div class="countdown-text" v-if="labels">Sec</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    date: null,
    labels: {
      type: Boolean,
      default: false,
      description: "Labels: days, hrs, min, seg"
    },
    type: {
      type: String,
      default: "sm",
      description: "sm-md-lg"
    },
  },
  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      finish: false,
      intervalId: null
    };
  },
  mounted() {
    this.startCountdown();
  },
  computed: {
    secondCount() {
      return this.calculatedDate - this.now;
    },
    calculatedDate() {
      return Math.trunc(Date.parse(this.event) / 1000);
    },
    seconds() {
      if (this.secondCount < 0) return 0;
      return this.secondCount % 60;
    },
    minutes() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60) % 60;
    },
    hours() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60 / 60) % 24;
    },
    days() {
      if (this.secondCount < 0) return 0;
      return Math.trunc(this.secondCount / 60 / 60 / 24);
    },
    event() {
      return this.date;
    }
  },
  methods: {
    startCountdown() {
      this.intervalId = setInterval(() => {
        this.now = Math.trunc(new Date().getTime() / 1000);
        if (!this.finish && this.secondCount <= 0) {
          this.finish = true;
          this.$emit("onFinish");
          this.clearCountdown();
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    twoDigits(value) {
      if (value.toString().length <= 1) {
        return "0" + value.toString();
      }
      return value.toString();
    }
  },
  beforeDestroy() {
    this.clearCountdown();
  }
};
</script>
